import { supabase } from '../lib/supabase'

export const DEMO_ACCOUNT_ID = 'c8fd8f9f-d45c-44b7-a33f-25d3f8ccb077'
export const DEMO_EMAIL = 'demo@debnix.com'
export const DEMO_PASSWORD = 'debnix-demo-2026'

export function isDemoMode(userId) {
  return userId === DEMO_ACCOUNT_ID
}

export async function loginAsDemo() {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: DEMO_EMAIL,
    password: DEMO_PASSWORD,
  })
  if (error) throw error
  return data
}